import {buildProductBriefText} from "./build-codex-prompt";

export function buildStrapiBackendBrief(brief, translate = (key) => key) {
    return [
        "# برگه محصول بک‌اند Strapi",
        "",
        "## خلاصه درخواست",
        field("نام فیچر یا تغییر", brief.featureName),
        field("نوع درخواست", brief.requestType),
        field("اولویت", brief.priority),
        field("درخواست‌دهنده", brief.requester),
        field("بخش‌های درگیر در فرانت", brief.involvedAreas),
        "",
        "## مسئله‌ای که بک‌اند باید پشتیبانی کند",
        field("مسئله", brief.problem),
        field("کاربر هدف", brief.targetUser),
        field("نقش کاربر هدف", brief.targetRole),
        field("نتیجه مورد انتظار", brief.expectedOutcome),
        "",
        "## سناریوهای محصول",
        listField("سناریوی کاربر", brief.userScenario),
        listField("معیارهای پذیرش", brief.acceptanceCriteria),
        listField("بخش‌های احتمالی متصل", brief.connectedAreas),
        "",
        "## دسترسی و مجوزها",
        roleTable("نقش‌های مجاز", brief.allowedRoles, ["role", "action", "description"]),
        roleTable("نقش‌های غیرمجاز", brief.deniedRoles, ["role", "limitation", "description"]),
        "",
        "## محدوده و ابهام‌ها",
        listField("خارج از Scope", brief.outOfScope),
        listField("ابهام‌ها و تصمیم‌های باز", brief.openQuestions),
        field("وابستگی‌ها یا قابلیت‌های موجود", brief.dependencies),
        field("Backend Receipt موجود", brief.technicalNotes?.backendReceiptPath),
        field("BCR موجود", brief.technicalNotes?.bcrPath),
        field("Endpoint یا Contract شناخته‌شده", brief.technicalNotes?.knownEndpointOrContract),
        field("توضیحات فنی اضافه", brief.technicalNotes?.extraNotes),
    ].join("\n");
}

export function buildStrapiBackendPrompt(brief, translate = (key) => key) {
    return [
        `# ${brief.featureName || "درخواست تغییر بک‌اند Strapi"}`,
        "",
        "تو در ریپوی Backend زوفینو با Strapi کار می‌کنی.",
        "این درخواست از Product Brief Builder فرانت ساخته شده و هدف آن بررسی و اعمال تغییرات لازم سمت بک‌اند است.",
        "",
        "## Product Brief",
        buildProductBriefText(brief, translate),
        "",
        "## Strapi Backend Brief",
        buildStrapiBackendBrief(brief, translate),
        "",
        "## Required Backend Workflow",
        "- ابتدا ساختار فعلی Strapi، content-typeها، controllers، routes، policies، services و lifecycles را بخوان.",
        "- هیچ content type، field، relation، controller، lifecycle یا route جدیدی را بدون نیاز واقعی ایجاد نکن.",
        "- اگر contract موجود نیاز را پوشش می‌دهد، فقط Backend Receipt بنویس و تغییر اضافه نده.",
        "- اگر backend support ناقص است، کمترین تغییر سازگار با ساختار فعلی Strapi را اعمال کن.",
        "- برای هر content type جدید، fields، relations، validations، draft/publish، workspace scope و ownership را مشخص کن.",
        "- برای هر endpoint یا route جدید، method، path، request body، query params، response، error shape و permission policy را مشخص کن.",
        "- اگر lifecycle، service یا controller سفارشی لازم است، دلیل، ورودی/خروجی و side effect آن را توضیح بده.",
        "- UI visibility فرانت را authorization فرض نکن؛ enforcement باید سمت بک‌اند باشد.",
        "- id/documentId rule را صریح مشخص کن.",
        "- migration یا data compatibility risk را مشخص کن.",
        "- تست‌های لازم backend و سناریوهای دستی را گزارش کن.",
        "- در پایان Backend Receipt قابل مصرف توسط فرانت بساز.",
        "",
        "## Required Contract Sections",
        "### Content Types",
        "- نام content type",
        "- existing/new",
        "- fields",
        "- relations",
        "- validations",
        "- workspace/project scope",
        "",
        "### API / Routes",
        "- method و path",
        "- auth requirement",
        "- permission policy",
        "- request examples",
        "- response examples",
        "- error examples",
        "",
        "### Controllers / Services / Lifecycles",
        "- فایل‌های تغییرکرده",
        "- دلیل تغییر",
        "- side effects مثل notification، audit log، socket event یا activity timeline",
        "",
        "### Frontend Receipt",
        "- endpointهای قابل مصرف",
        "- fieldها و relationهای تأییدشده",
        "- permission behavior",
        "- migration notes",
        "- مواردی که فرانت نباید فرض کند",
        "",
        "## Expected Output",
        "- Architecture summary",
        "- Files changed",
        "- Content types changed or added",
        "- Routes/controllers/services/lifecycles changed or added",
        "- API contracts",
        "- Permission behavior",
        "- Migration notes",
        "- Backend Receipt for frontend",
        "- Manual/backend test scenarios",
        "- Blockers and decisions",
    ].join("\n");
}

function field(label, value) {
    return `- ${label}: ${String(value || "تکمیل نشده").trim() || "تکمیل نشده"}`;
}

function listField(label, items) {
    const values = (items || []).filter((item) => String(item || "").trim());
    if (!values.length) return `- ${label}: تکمیل نشده`;
    return [`- ${label}:`, ...values.map((item) => `  - ${item}`)].join("\n");
}

function roleTable(label, items, keys) {
    const values = (items || []).filter((item) => keys.some((key) => String(item?.[key] || "").trim()));
    if (!values.length) return `- ${label}: تکمیل نشده`;
    return [
        `- ${label}:`,
        ...values.map((item) => `  - ${keys.map((key) => item?.[key]).filter(Boolean).join(" | ")}`),
    ].join("\n");
}
